import axios from "axios";

export const apiURL = "https://marinedebris.engr.uga.edu/mdtapp";

export const apiRequest = axios.create({
  baseURL: apiURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchBottleData = async () => {
  try {
    let res: any = await apiRequest.get(`/bottleData.php`);
    return res.data.data;
  } catch (err) {
    return [];
  }
};
